export const ROLE = {
    'ADMIN': 'admin',
    'SERVICE': 'service',
    'SALES': 'sales',
    'PRODUCTION': 'production',
}